import { Search, X } from 'lucide-react';
import Button from '../ui/Button';
import type { KnowledgeBaseFilters } from '../../types/knowledge';

interface KnowledgeBaseFiltersProps {
  filters: KnowledgeBaseFilters;
  onChange: (filters: KnowledgeBaseFilters) => void;
  onClear: () => void;
}

function KnowledgeBaseFiltersBar({ filters, onChange, onClear }: KnowledgeBaseFiltersProps) {
  const hasActiveFilters = filters.category !== undefined || filters.search !== undefined;

  return (
    <div className="mb-4 flex flex-col gap-3 sm:flex-row sm:items-end sm:gap-4">
      <div className="sm:w-56">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Categoria
        </label>
        <input
          type="text"
          value={filters.category || ''}
          onChange={e => onChange({ ...filters, category: e.target.value || undefined })}
          placeholder="Filtrar por categoria"
          className="block w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:border-primary-500 focus:ring-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200"
        />
      </div>

      <div className="flex-1">
        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
          Buscar
        </label>
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            type="text"
            value={filters.search || ''}
            onChange={e => onChange({ ...filters, search: e.target.value || undefined })}
            placeholder="Buscar por nome ou conteúdo..."
            className="block w-full pl-9 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:border-primary-500 focus:ring-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:text-gray-200"
          />
        </div>
      </div>

      {hasActiveFilters && (
        <Button variant="secondary" onClick={onClear} className="sm:mb-0.5">
          <X className="h-4 w-4 mr-1" />
          Limpar
        </Button>
      )}
    </div>
  );
}

export default KnowledgeBaseFiltersBar;
